
import { imageURLPrefix, isEntitled, isInternal } from "../helpers.mjs";

function getBookBands() {

    let bookBands = { "163": "Banded books", "199": "White", "200": "Grey", "201": "Dark Red", "202": "Dark Blue", "203": "Purple", "204": "Gold", "205": "Turquoise", "206": "Blue", "207": "Yellow", "208": "Black", "209": "Brown", "210": "Pink", "211": "Orange", "212": "Lime", "213": "Green", "214": "Red", "215": "Lilac" };

    window.bookBands = bookBands;

    return bookBands;
}

function resetBookSizeCheckbox() {
    var showBookSizeInput = $("#showBookSize");
    if (showBookSizeInput.length && $(window).width() > 1070 && showBookSizeInput.prop("checked")) {
        showBookSizeInput.prop('checked', false);
    }
}

function initSwiperRelatedCarousels() {
    var relatedProductsCarousels = document.querySelectorAll('.relatedProducts');
    // var isInitialised = false;
    // var isDestroyed = false;

    var carouselBreakpoints = {
        6: {
            1024: {
                slidesPerView: 6,
                slidesPerGroup: 6,
            },
            920: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },
            769: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            650: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            480: {
                slidesPerView: 4,
                slidesPerGroup: 4
            }
        },
        8: {
            1024: {
                slidesPerView: 8,
                slidesPerGroup: 8,
            },
            920: {
                slidesPerView: 5,
                slidesPerGroup: 5,
            },
            800: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },
            600: {
                slidesPerView: 3,
                slidesPerGroup: 3
            },
            480: {
                slidesPerView: 4,
                slidesPerGroup: 4
            }
        }
    };

    relatedProductsCarousels.forEach(function(carousel, index) {
        var carouselId = carousel.id;
        var slider = carousel.querySelector('.swiper-container');
        var noSlides = parseInt(carousel.dataset.slides);
        var slidetoshowcount = parseInt(carousel.getAttribute('slidetoshowcount'));
        var autoplay = carousel.getAttribute('autoplay') != null ? true : false;
        carousel.setAttribute('data-carousel', "swiper");

        // If Swiper already exists, then delete it before init?
        if (slider) {
            const swiper = slider.swiper;
            if (swiper) {
                swiper.destroy();
            }
        }

        if (!slider.classList.contains("swiper-container-initialized") && window.innerWidth > 481) {
            
            // get minimum
            var breakpoints = carouselBreakpoints[slidetoshowcount]
            var slidesPerView = slidetoshowcount;
            for (var width in breakpoints) {
                if (window.innerWidth > width) {
                    continue;
                }else{
                    slidesPerView = breakpoints[width]["slidesPerView"];
                    break;
                }
            };
            
            //console.log(carousel.id, noSlides > slidesPerView);
            
            window.swiper[index] = new Swiper('#' + carouselId + ' .swiper-container', {
                // Disable preloading of all images
                preloadImages: slidesPerView > noSlides,
                checkInView: true,
                // Enable lazy loading
                lazy: true,
                watchSlidesVisibility: true,
                spaceBetween: 10,
                centerInsufficientSlides: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: carouselBreakpoints[slidetoshowcount],
                autoplay: autoplay,
                on: {
                    beforeInit: function () {
                        if ($("#" + carouselId + " .sliderOverlay").length) carousel.querySelector(".sliderOverlay").style.display = "block";
                    },
                    init: function () {
                        if ($("#" + carouselId + " .sliderOverlay").length) carousel.querySelector(".sliderOverlay").style.display = "none";
                    },
                    beforeDestroy: function () {
                        if ($("#" + carouselId + " .sliderOverlay").length) carousel.querySelector(".sliderOverlay").style.display = "block";
                    },
                    destroy: function () {
                        if ($("#" + carouselId + " .sliderOverlay").length) carousel.querySelector(".sliderOverlay").style.display = "none";
                    },
                    lazyImageLoad: function (swiper, slideEl, imageEl) {
                        //set backup
                        if (!imageEl.dataset.backupSrc) {
                            var imageSrc = imageEl.dataset.src;
                            imageEl.setAttribute("data-backup-src", imageSrc);
                        }

                    },
                    lazyImageReady: function (swiper, slideEl, imageEl) {
                        //use backup to recreate data-src
                        if (imageEl.src && !imageEl.dataset.src) {
                            var backupSrc = imageEl.dataset.backupSrc;
                            imageEl.setAttribute("data-src", backupSrc);
                        }

                    },
                    afterInit: function (swiper) {
                        var navHack = false;
                        //Hack for some reason on libraries the next button is disabled.
                        if (swiper.navigation.nextEl && swiper.navigation.nextEl.classList.contains("swiper-button-disabled")) {
                            swiper.navigation.nextEl.disabled = false;
                            swiper.navigation.nextEl.classList.remove('swiper-button-disabled');
                            swiper.navigation.nextEl.removeAttribute("aria-disabled"); 
                            navHack = true;                           
                        }

                        if (swiper.navigation.nextEl && swiper.navigation.prevEl.classList.contains("swiper-button-disabled")) {
                            swiper.navigation.prevEl.disabled = false;
                            swiper.navigation.prevEl.classList.remove('swiper-button-disabled');
                            swiper.navigation.prevEl.removeAttribute("aria-disabled");  
                            navHack = true;                           
                        }                        


                        if (navHack) {
                            swiper.navigation.update();
                        }
                    }
                },
            });
        } else if (slider.classList.contains("swiper-container-initialized") && window.innerWidth < 480) {

            window.swiper[index].destroy(true, true);
            if (index === relatedProductsCarousels.length - 1) {
                window.swiper = [];
            }
        } else {
            
            if ($("#" + carouselId + " .sliderOverlay").length) carousel.querySelector(".sliderOverlay").style.display = "none";
            
            // lazyload images in mobile grid view
            var visibleSlides = carousel.querySelectorAll(".swiper-container .swiper-slide:not(:nth-of-type(n + 5))");
            visibleSlides.forEach(function (slide) {
                var slideImage = slide.querySelector(".swiper-lazy");
                if (slideImage !== null) slideImage.src = slideImage.dataset.src;
            });
        }
        //console.log(carousel.id, " is complete");
    });
}

const initBookPage = () => {
    var hash = window.location.hash.substr(1);

    // var prId = $('.productContainer').data('id');
    var linkedProductEan13 = $('.productContainer').data('ean13linked');
    // var bookPack = $('.productContainer').data('bookPack');

    if (linkedProductEan13) {
        if (window.location.href.indexOf("book-page") > -1 || window.location.href.indexOf("cgi-bin") > -1) {
            var obj = "";
            var urlEncodedEan = encodeURIComponent(linkedProductEan13);
            // history.pushState(obj, '', '/book-page/' + urlEncodedEan);
        }
    }

    if (window.location.href.indexOf("resources") > -1) {
        $('#resources').trigger('click');
    }

    // Scroll page to top?
    window.scrollTo(0, 0);

    $('body').on('click', 'ul.productPageTabs .productTab', function () {
        // var tab_id = $(this).attr('data-tab');

        // $('ul.productPageTabs li').removeClass('current');
        // $('.tabContent').removeClass('current');

        // var $contentToShow = $("#" + tab_id);

        // $contentToShow.css('opacity', 0);
        // $(this).addClass('current');
        // $contentToShow.addClass('current');

        // document.cookie = "bookPageTab="+tab_id+"; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";

        // $('.tabContainer').height($('.tabContent.current').height() + 50);

        // setTimeout(function() {
        //     $contentToShow.css('opacity', 1);
        // }, (110));


    });

    $('body').on('click', '.altEditionItem', function (e) {
        window.location.href = "/book-page/" + $(this).attr('ean');
    });

    $('body').on('click', '#myNotesSave', function (e) {
        e.stopImmediatePropagation();

        var $saveButton = $(this);
        var $bookNotesLastEdited = $(this).siblings('.bookNotesLastEdited');
        var productEan = $('#productEan').val();
        var myNotesText = $('#myNotesInput').val();
        $saveButton.addClass('disabled');
        $saveButton.text('Saving...');

        $.ajax({
            method: 'POST',
            cache: false,
            url: '/user/updateNotes',
            data: {
                notes: myNotesText,
                ean13: productEan,
            }
        }).done(function (e) {
            $saveButton.text('Saved!');
            $bookNotesLastEdited.text(`Last edited: ${new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'medium' }).format(new Date(e))}`)
            setTimeout(function(){ $saveButton.removeClass('disabled'); $saveButton.text('Save changes'); }, 5000);
        }).fail(function() {
            alert("Failed to save note, please try again.");
        });
    });

    $(document).on('keyup', function (e) {
        if (e.keyCode == 27) {
            $('.lightbox').fadeOut(function () {
                $('#lightbox').remove();
            });
        }
    });

    var $currentTab = $('.productTab.current').first();
    if (!$currentTab.length) {
        $currentTab = $('.productTab').first();
        $currentTab.addClass('current');
    }

    var tab_id = $currentTab.attr('data-tab');
    $("#" + tab_id).addClass('current');
    $('.tabContainer').height($('.tabContent.current').height() + 50);

    $(window).on('resize', function (e) {
        e.preventDefault();
        $('.tabContainer').height($('.tabContent.current').height() + 50);
        resetBookSizeCheckbox();
        initSwiperRelatedCarousels();
    });

    $('span.noStock').each(function () {
        if (!isInternal()) {
            $(this).parents('.productContainer').find('.addButtonContainer:not(.bookshelf)').addClass('disabled');
            $(this).parents('.bookInfo').find('.addToBasket:not(.bookshelfButton) p').text('Not available to order');
            $(this).parents('.bookInfo').find('.quantitySection').remove();
            //$(this).parents('.bookInfo').find('.addToBasketSelectWrapper').remove();
            var basketSelect = $(this).parents('.bookInfo').find('.addButtonContainer.disabled .addToBasketSelectWrapper');
            var inbasket = basketSelect.find('option:selected').data('inbasket');
            if (!inbasket) {
                basketSelect.remove();
            }
        }
    });

    $('.bookPrice.disableAddToBasket').each(function () {
        if (!isInternal()) {
            $(this).parents('.productContainer').find('.addButtonContainer:not(.bookshelf)').addClass('disabled');
            $(this).parents('.bookInfo').find('.addToBasket:not(.bookshelfButton) p').text('Not available to order');
            $(this).parents('.bookInfo').find('.quantitySection').remove();
            //$(this).parents('.bookInfo').find('.addToBasketSelectWrapper').remove();
            var basketSelect = $(this).parents('.bookInfo').find('.addButtonContainer.disabled .addToBasketSelectWrapper');
            var inbasket = basketSelect.find('option:selected').data('inbasket');
            if (!inbasket) {
                basketSelect.remove();
            }
        }
    });

    $('#resourcesList a:not([href])').on('click', function () {
        $('#noDownloadPopup').fadeIn('fast');
    });

    $('.popupCancel').on('click', function () {
        $(this).parents('.popup').fadeOut();
    });

    if (hash && $('#' + hash).length) {
        $('#' + hash).trigger('click');
    }

    setTimeout(function() {
        if (!window.swiper) {
            window.swiper = [];
        }
        
        initSwiperRelatedCarousels();
    }, 1200);
}

function getBookImageLinks(ean) {
    return {
        "cover":        `${imageURLPrefix()}/covers/large/${ean.substring(ean.length - 3)}/${ean}.jpg`,
        "centerfold":   `${imageURLPrefix()}/cfolds/large/${ean.substring(ean.length - 3)}/${ean}.jpg`,
        "backcover":    `${imageURLPrefix()}/cfolds/large/${ean.substring(ean.length - 3)}/${ean}_1.jpg`,
        "additional2":  `${imageURLPrefix()}/cfolds/large/${ean.substring(ean.length - 3)}/${ean}_2.jpg`,
        "additional3":  `${imageURLPrefix()}/cfolds/large/${ean.substring(ean.length - 3)}/${ean}_3.jpg`,
        "additional4":  `${imageURLPrefix()}/cfolds/large/${ean.substring(ean.length - 3)}/${ean}_4.jpg`,
        "additional5":  `${imageURLPrefix()}/cfolds/large/${ean.substring(ean.length - 3)}/${ean}_5.jpg`,
        "additional6":  `${imageURLPrefix()}/cfolds/large/${ean.substring(ean.length - 3)}/${ean}_6.jpg`,
        "additional7":  `${imageURLPrefix()}/cfolds/large/${ean.substring(ean.length - 3)}/${ean}_7.jpg`
    };
}

// Source: https://gomakethings.com/how-to-add-a-new-item-to-an-object-at-a-specific-position-with-vanilla-js/
function addToObject(obj, key, value, index) {

    // Create a temp object and index variable
    var temp = {};
    var i = 0;

    // Loop through the original object
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {

            // If the indexes match, add the new item
            if (i === index && key && value) {
                temp[key] = value;
            }

            // Add the current item in the loop to the temp obj
            temp[prop] = obj[prop];

            // Increase the count
            i++;

        }
    }

    // If no index, add to the end
    if (!index && key && value) {
        temp[key] = value;
    }

    return temp;

};

function getFormattedDate(dateString, options = { year: 'numeric', month: 'short', day: 'numeric' }) {

    let date = new Date(dateString);
    return date.toLocaleString("en-GB", options);

}

function getFormattedPrice(number, locale = 'en-GB', options = { style: 'currency', currency: 'GBP' }) {

    return Intl.NumberFormat(locale, options).format(number);

}

function getAgeLevelsText(lower = false, upper = false) {
    let result = false;

    if (lower && !upper) {
        result = `${lower} yrs and above`;
    }

    if (!lower && upper) {
        result = `up to ${upper} yrs`;
    }

    if (lower && upper) {
        result = `${lower} - ${upper} yrs`;
    }

    return result;
}

// https://stackoverflow.com/a/18837813/17925911

const showRatings = r => isEntitled() && r.evaluation && (r.evaluation.includes('Not reviewed by Peters') === false) && (r.evaluation.includes('not reviewed by Peters') === false);

const pubAssessmentScore = r => {
    if(r.libs_post > 0) {
        return(r.libs_post);
    } else if(r.libs_pre > 0) { // r.pre_pub_assessment_date && ...
        return(r.libs_pre);
    }
    return 0;
}

const LIBRARY_SUITABILITY = {
    0: 'Not recommended, not suitable for library use',
    1: 'Niche use, suitable for specific needs, or for large or central library collections/budgets',
    2: 'Good choice, suitable for most types of library/collection or budget',
    3: 'Must-have, suitable for any type of library/collection or budget'
}

const SCHOOL_SUITABILITY = {
    0: 'Not suitable for schools',
    1: 'May have some use in schools, as needed',
    2: 'Recommended for schools',
    3: 'Ideal for school libraries and classrooms'
}

const BOOK_KEYSTAGES = {
    '29': 'Foundation',
    '30': 'Key Stage 1',
    '31': 'Key Stage 2',
    '32': 'Key Stage 3',
    '33': 'Key Stage 4',
    '34': 'Key Stage 5'
}

const BOOK_SUITABILITIES = {
    '228': 'Primary',
    '229': 'Secondary',
    '230': 'EYFS',
    '231': 'KS1',
    '232': 'KS2 Lower',
    '233': 'KS2 Upper',
    '234': 'KS3',
    '235': 'KS4',
    '236': 'KS5',
    '237': 'Adult',
    '250': 'Year 13',
    '251': 'Year 12',
    '252': 'Year 3',
    '253': 'Year 2',
    '254': 'Year 1',
    '255': 'Year 7',
    '256': 'Year 6',
    '257': 'Year 5',
    '258': 'Year 4',
    '259': 'Year 8',
    '260': 'Year 11',
    '261': 'Year 10',
    '262': 'Reception',
    '263': 'Foundation',
    '264': 'Year 9'
}

export {
    getBookBands,
    resetBookSizeCheckbox,
    initBookPage,
    initSwiperRelatedCarousels,
    getBookImageLinks,
    addToObject,
    getFormattedDate,
    getFormattedPrice,
    getAgeLevelsText,
    showRatings,
    pubAssessmentScore,
    LIBRARY_SUITABILITY,
    SCHOOL_SUITABILITY,
    BOOK_KEYSTAGES,
    BOOK_SUITABILITIES
};